import { IconButton, Tooltip } from '@mui/material';
import { currentUserActions, useCurrentUserStorage } from '@pn/core/storage';
import EngineeringIcon from '@mui/icons-material/Engineering';

export function AdminModeToggleButton() {
  const { isAdminMode, user } = useCurrentUserStorage();

  const handleToggle = () => currentUserActions().toggleAdminMode();

  if (!user?.isAdmin) return null;

  return (
    <Tooltip title="Toggle administrator mode">
      <IconButton onClick={handleToggle}>
        <EngineeringIcon color={isAdminMode ? 'primary' : 'inherit'} />
      </IconButton>
    </Tooltip>
  );
}
